<ng-template #ticketoffer>
    <ng-container *ngIf="ofrdisplay">
        <ion-item>
            <div class="thumb-box" slot="start" uppDataid="ticketoffer-image-info">
                <div class="image-box">
                    <upp-image [src]="ofrdisplay.photo || ofrdisplay.avatar"></upp-image>
                </div>
                <ion-badge uppDataid="ticketoffer-count-badge" color="danger">{{ofrdisplay.amount}}</ion-badge>
            </div>    
            <div class="products" uppDataid="ticketoffer-products-click" tabindex="0" (click)="OnShowProducts()" (keydown.enter)="OnShowProducts()" (keydown.space)="OnShowProducts()">
                <ion-item class="name" lines="none">
                    <ion-label>{{ofrdisplay.amount + " x " + ofrdisplay.name}}</ion-label>
                    <ion-buttons slot="end">
                        <ion-icon *ngIf="ShowProducts === true" name="chevron-up-outline"></ion-icon>
                        <ion-icon *ngIf="ShowProducts !== true" name="chevron-down-outline"></ion-icon>    
                    </ion-buttons>                  
                </ion-item>
       
                <ion-list class="products" [ngClass]="{ 'visible': ShowProducts }">   
                    <!-- OFFER INFORMATION --> 
                    <ion-item uppDataid="ticketoffer-brief-title" lines="full">
                        <ion-icon *ngIf="ofrdisplay.available === true" slot="start" color="success" name="star-outline"></ion-icon>
                        <ion-icon *ngIf="ofrdisplay.available !== true" slot="start" color="warning" name="warning-outline"></ion-icon>
                        <ion-label color="medium">
                            {{ofrdisplay.name}}
                        </ion-label>
                        <ion-label *ngIf="ofrdisplay.price" color="medium" slot="end">
                            <b>{{ofrdisplay.price}}{{tr('@currency')}}</b>
                        </ion-label>
                    </ion-item>  
    
                    <!-- OFFER PRODUCTS -->
                    <ng-container *ngFor="let product of ofrdisplay.products; trackBy: ProductTrack">
                        <ion-item uppDataid="ticketoffer-brief-product" lines="full">
                            <ion-icon *ngIf="product.available === true" slot="start" color="success" name="wine-outline"></ion-icon>
                            <ion-icon *ngIf="product.available !== true" slot="start" color="warning" name="warning-outline"></ion-icon>
                            <ion-label color="medium">
                                {{product.amount + " x " + product.name}}
                            </ion-label>
                            <ion-label  color="medium" slot="end">
                                0.00{{tr('@currency')}}
                            </ion-label>                    
                        </ion-item>    
                    </ng-container>
                </ion-list>        
    
                <!-- OFFER PRICE BRIEF -->
                <ion-list  class="prices">
                    <!-- original price -->
                    <ion-item uppDataid="ticketoffer-brief-price" [ngClass]="{ 'strike': ofrdisplay.isfixed }">
                        <ion-label color="success">{{ofrdisplay.amount}} x {{ofrdisplay.price + tr('@currency')}}</ion-label>
                        <ion-label class="price" color="success" slot="end">
                            <b>{{ofrdisplay.totalprice}}{{tr('@currency')}}</b>
                        </ion-label>                        
                    </ion-item>        
                    <!-- fixed price -->
                    <ion-item uppDataid="ticketoffer-brief-fixed" *ngIf="ofrdisplay.isfixed">
                        <ion-label color="success">
                            <span *ngIf="ofrdisplay.onthehouse !== true">{{tr('@place_fixed_applied')}}</span>
                            <span *ngIf="ofrdisplay.onthehouse === true">{{tr('@place_fixed_on_the_house')}}</span>
                        </ion-label>                    
                        <ion-label color="success" slot="end" style="text-align:right">
                            <b>{{ofrdisplay.totalfixed}}{{tr('@currency')}}</b>
                        </ion-label>                        
                    </ion-item>    
                </ion-list>            
            </div>
        </ion-item>
    
        <!-- TICKETOFFER PAYMENT STATUS -->
        <ng-container *ngIf="ofrdisplay.ticket">
            <ion-item uppDataid="ticketoffer-paid-info" *ngIf="ofrdisplay.paidstatus" class="event center">
                <ion-label [color]="EventColor(ofrdisplay.paidstatus)">
                    {{tr('@place_event_type_' + ofrdisplay.paidstatus)}}
                </ion-label>
            </ion-item>
        </ng-container>        
    </ng-container>
</ng-template>

<ng-template #discountcontent>
    <ion-item *ngIf="dctdisplay">
        <div class="thumb-box" slot="start" uppDataid="ticketoffer-image-info">
            <div class="image-box">
                <upp-image [src]="dctdisplay.photo || dctdisplay.avatar"></upp-image>
            </div>
        </div>    
        <div class="info">
            <ion-item>
                <ion-label>
                    {{dctdisplay.name || tr('@ticket_offer_noname')}}<br/>
                    <ng-container *ngIf="dctdisplay.description !== null">
                        <span class="small">{{dctdisplay.description}}</span>
                    </ng-container>
                    <ng-container *ngIf="dctdisplay.description === null">
                        <span class="small" *ngIf="dctdisplay.type === 'TICKETFIXED'">{{tr('@place_discount_fixed_applied')}}</span>
                        <span class="small" *ngIf="dctdisplay.type === 'TICKETPRCNT'">{{tr('@place_discount_prcnt_applied', [ dctdisplay.value ])}}</span>
                    </ng-container>
                </ion-label>
                <ng-container *ngIf="dctdisplay.chargeinfo">
                    <ion-label color="medium" class="price" style="font-size: 30px;" slot="end">
                        - {{dctdisplay.chargeinfo.int}}<span class="decimal">,{{dctdisplay.chargeinfo.dec}}</span>{{tr('@currency')}}
                    </ion-label>    
                </ng-container>              
            </ion-item>
            <ng-container *ngIf="dctdisplay.refundinfo">
                <ion-item class="refund" uppDataid="ticketoffer-refund-info">
                    <ion-label color="danger">{{tr('@place_discount_refund_pending')}}</ion-label>
                    <ion-label color="danger" slot="end">
                        <b>+ {{dctdisplay.refundinfo.str}}{{tr('@currency')}}</b>
                    </ion-label>
                </ion-item>    
            </ng-container>            
        </div>
    </ion-item>    
</ng-template>

<ng-template #ticketdiscount>
    <upp-visible-control mode="content">
        <ng-container *ngIf="mode === 'VIEW'">
            <ng-container [ngTemplateOutlet]="discountcontent"></ng-container>
        </ng-container>
        <ng-container *ngIf="mode === 'EDIT'">
            <ion-item-sliding *ngIf="dctdisplay" #slider>
                <ng-container [ngTemplateOutlet]="discountcontent"></ng-container>
                <ion-item-options side="end">
                    <ion-item-option [hidden]="IsSliding" (click)="RemoveDiscount($event, slider)">
                        <ion-item class="options" lines="none">
                            <ion-button uppDataid="ticketoffer-del-button" mode="md" slot="icon-only" fill="clear" slot="end">
                                <ion-icon color="danger" name="close-circle-outline"></ion-icon>  
                            </ion-button>
                        </ion-item>
                    </ion-item-option>
                </ion-item-options>           
            </ion-item-sliding>    
        </ng-container>
    </upp-visible-control>
</ng-template>

<upp-visible-control mode="content">
    <ng-container *ngIf="offer" [ngTemplateOutlet]="ticketoffer"></ng-container>
    <ng-container *ngIf="discount" [ngTemplateOutlet]="ticketdiscount"></ng-container>
</upp-visible-control>
